import { EventEmitter } from "events";
import AppDispatcher from '../AppDispatcher';

class AppStore extends EventEmitter {
    constructor() {
        super();

        //#! Set the default store data
        this.__defaultData = {
            page: 'brands',
            loading: false,
            page_data: {},
            same_request: false,
        };

        this.data = this.__defaultData;

        AppDispatcher.register( this.handleActions.bind( this ) );
    }

    updatePage(pageName) {
        this.data.page = pageName;
    }

    getData() {
        return this.data;
    }

    __loading(yesNo) {
        this.data.loading = yesNo;
    }

    __updateStoreData(data = {}) {
        this.data = { ...this.data, ...data };
    }

    /**
     * Handle the requested action
     * @param {{}} action
     */
    handleActions(action = { type: '', payload: '' }) {
        switch ( action.type.toUpperCase() ) {
            case "UPDATE_PAGE": {
                this.updatePage( action.payload );
                this.emit( 'change' );
                break;
            }
            case "GET_DATA": {
                this.emit( "change" );
                break;
            }
            case "RESET_DATA": {
                this.data = this.__defaultData;
                this.emit( "change" );
                break;
            }
            case "SET_LOADING": {
                this.__loading( action.payload );
                this.emit( "change" );
                break;
            }
            case "UPDATE_STORE": {
                this.__updateStoreData( action.payload );
                this.emit( "change" );
                break;
            }
        }
    }
}

export default new AppStore();
